import { createContext, useContext } from "react";
import { assert } from "utils";

import { type WorkoutsRepository } from "src/repositories/workouts/WorkoutsRepository";

export const WorkoutsRepositoryContext =
  createContext<WorkoutsRepository | null>(null);

export function useWorkoutsRepository(): WorkoutsRepository {
  const repository = useContext(WorkoutsRepositoryContext);
  assert(repository, "WorkoutsRepositoryContext is missing");
  return repository;
}
